import { navItems } from "@/mocks/content";

const browseHints = [
  "韩剧TV在线观看",
  "韩剧TV免费看剧",
  "韩剧TV网页版入口",
  "韩剧TV在线播放",
  "韩剧TV手机在线看",
  "韩剧TV在线观看网站",
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-tv-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">韩剧TV</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-200">
              一个围绕韩剧在线观看的信息整理页面，涵盖热门剧目推荐、网页版入口与手机在线看的观看指南、
              周更上线节奏以及实用的追剧攻略，帮助你更高效地安排追剧时间。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 space-y-2">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">浏览线索</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {browseHints.map((hint) => (
                <li
                  key={hint}
                  className="rounded-full bg-primary-900 px-3 py-1 text-xs text-background-200"
                >
                  {hint}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-6 text-background-300">
            本站为信息整理页面，不提供、不存放任何影视资源，内容仅供参考。
          </p>
          <p className="text-xs text-background-300">© {year} 韩剧TV · 在线观看与追剧指南</p>
        </div>
      </div>
    </footer>
  );
}